import type { AddShopMemberWithTokenDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

interface UseAddShopMemberParams {
	onSuccess: () => void;
	onError: () => void;
}

export default function useAddShopMembers(params: UseAddShopMemberParams) {
	return useApiMutation("post", "/public/shops/{shopId}/members/token", {
		onSuccess: params.onSuccess,
		onError: params.onError,
		mapVariables: ({
			requestBody,
			shopId,
		}: {
			requestBody: AddShopMemberWithTokenDto;
			shopId: string;
		}) => ({
			params: { path: { shopId } },
			body: requestBody,
		}),
	});
}
